import { Card, ROW_TYPE, publishEvent } from '@uma/react-commons/dist/index';
import React from 'react';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import {
  ManageAdvancedSecurityOptionsHyperlinkClicked,
  MobileTwoFactorAuthHyperlinkClicked
} from './analytics';
import { URLS } from 'src/utils/urls';
import { FeatureFlagProps } from 'src/App';
import Loader from '../Loader';

const AdvancedSecurityOptions = (featureFlagProps: FeatureFlagProps) => {
  const { translate } = useDependencyManagerContext();

  const { isLoading, securityHPIDMfa } = featureFlagProps;

  const htmlString = translate(
    'security.advancedSecurityOptionsDescription',
    'Add an extra layer of security to your account using a one-time security code in addition to your password with {{tagReplaceStart}}mobile two-factor authentication{{tagReplaceEnd}}.'
  );
  const parts = htmlString.split(/{{\/?tagReplaceStart}}|{{\/?tagReplaceEnd}}/);

  if (isLoading) {
    return <Loader />;
  }

  if (!isLoading && !securityHPIDMfa) {
    return (
      <Card
        title={{
          content: `${translate(
            'security.advancedSecurityOptions',
            'Advanced security options'
          )}`,
          type: ROW_TYPE.EXTERNAL,
          link: {
            url: URLS.HpIdSecurity,
            dataTestId: 'AdvancedSecurityOptionsLink'
          },
          analyticsEvent: ManageAdvancedSecurityOptionsHyperlinkClicked
        }}
        rowsColorChangeEnabled={false}
        data-testid="AdvancedSecurityOptions"
      >
        <div className="caption">
          {parts[0]}
          <a
            data-testid="MobileTwoFactorAuthHyperlink"
            href={URLS.MobileTwoFactorAuth}
            onClick={() => publishEvent(MobileTwoFactorAuthHyperlinkClicked)}
            target="_blank"
            rel="noreferrer"
            style={{ color: '#024ad8' }}
          >
            {parts[1]}
          </a>
          {parts[2]}
        </div>
      </Card>
    );
  }
  return null;
};

export default AdvancedSecurityOptions;
